// extracted by mini-css-extract-plugin
module.exports = {"content":"LocalMerchant_style_content__Hm2Rz","content_main":"LocalMerchant_style_content_main__1h73V"};